export const ResearchAcceleration = [
  {
    title: "Speed Advantage",
    description:
      "Assess market opportunities before competitors start their research",
    img: "/json-media/img/SolutionPage/speedAdvantage.svg",
    alt: "Speed Advantage"
  },
  {
    title: "Complete Analysis",
    description: "Access VIPs and niche personas instantly",
    img: "/json-media/img/SolutionPage/completeAnalysis.svg",
    alt: "Complete Analysis"
  },
  {
    title: "Unlimited Scope",
    description: "No survey fatigue, ask as many questions as needed",
    img: "/json-media/img/SolutionPage/unlimtedScope.svg",
    alt: "Unlimited Scope"
  },
  {
    title: "No Incentive Costs",
    description:
      "Eliminate recruitment expenses and respondent payments",
    img: "/json-media/img/SolutionPage/noIncentiveCost.svg",
    alt: "No Incentive Costs"
  },
  {
    title: "Rich Respondent Profiles",
    description:
      "Thousands of data attributes per respondent from verified data sources",
    img: "/json-media/img/SolutionPage/richRespondent.svg",
    alt: "Rich Respondent Profiles"
  },
  {
    title: "Hard-to-Reach Segments",
    description:
      "Full statistical framework with clustering and segmentation",
    img: "/json-media/img/SolutionPage/HtoR.svg",
    alt: "Hard-to-Reach Segments"
  }
];

export const SuperiorSurveyBasedResearch = [
  {
    title: "Unlimited Length",
    description: "Ask 100+ questions without respondent fatigue",
    img: "/json-media/img/SolutionPage/uL.svg",
    alt: "Unlimited Length"
  },
  {
    title: "No Incentive Costs",
    description: "Eliminate recruitment expenses and respondent payments",
    img: "/json-media/img/SolutionPage/nnc.svg",
    alt: "No Incentive Costs"
  },
  {
    title: "100% Completion Rate",
    description: "No survey abandonment or partial responses",
    img: "/json-media/img/SolutionPage/hunderendcr.svg",
    alt: "100% Completion Rate"
  },
  {
    title: "No Social Desirability Bias",
    description: "Direct, honest responses even on sensitive topics",
    img: "/json-media/img/SolutionPage/nsdb.svg",
    alt: "No Social Desirability Bias"
  },
  {
    title: "Complex Questioning",
    description: "Deep explorations without concern for respondent patience",
    img: "/json-media/img/SolutionPage/cq.svg",
    alt: "Complex Questioning"
  },
  {
    title: "Instant Fielding",
    description:
      "No recruitment delays or scheduling challenges. Results within hours of “go”",
    img: "/json-media/img/SolutionPage/IF.svg",
    alt: "Instant Fielding"
  }
];
export const DataDepthAdvantage = [
  {
    title: "Millions of Profiles",
    description:
      "Robust, representative database that includes every possible target segment within the U.S.",
    img: "/json-media/img/SolutionPage/mop.svg",
    alt: "Millions of Profiles"
  },
  {
    title: "Granular Targeting",
    description:
      "Want to talk to single mothers in eastern Kentucky who drive Teslas? You got it. College students who work part-time jobs? We’ve got you covered.",
    img: "/json-media/img/SolutionPage/gt.svg",
    alt: "Granular Targeting"
  },
  {
    title: "Targeting Models",
    description:
      "Ability to develop prospecting models for each proprietary segment, including your ideal customer profile",
    img: "/json-media/img/SolutionPage/tm.svg",
    alt: "Targeting Models"
  },
  {
    title: "Psychographic Depth",
    description:
      "Values, motivations, and lifestyle factors professionally modeled",
    img: "/json-media/img/SolutionPage/pd.svg",
    alt: "Psychographic Depth"
  },
  {
    title: "Behavioral Insights",
    description:
      "Purchase patterns, preferences, and decision-making styles",
    img: "/json-media/img/SolutionPage/bi.svg",
    alt: "Behavioral Insights"
  },
  {
    title: "No Self-Reporting Bias",
    description:
      "Compiled data eliminates the inaccuracies of self-reported information",
    img: "/json-media/img/SolutionPage/nsrb.svg",
    alt: "No Self-Reporting Bias"
  }
];
export const InsightfulProprietarySegments = [
  {
    title: "Rich Data Foundation",
    description:
      "Thousands of profiling attributes per respondent from verified sources, not self-reported data",
    img: "/json-media/img/SolutionPage/RDF.svg",
    alt: "Rich Data Foundation"
  },
  {
    title: "Unlimited Questioning",
    description:
      "Deep customer understanding through complete answers to all questions, with no survey fatigu",
    img: "/json-media/img/SolutionPage/UQ.svg",
    alt: "Unlimited Questioning"
  },
  {
    title: "Proprietary Segment Discovery",
    description:
      "Business-relevant clustering based on comprehensive profiles",
    img: "/json-media/img/SolutionPage/PSD.svg",
    alt: "Proprietary Segment Discovery"
  }
];
export const InteractiveSegmentAvatars = [
  {
    title: "Ongoing Dialogue",
    description:
      "Move beyond one-time studies to continuous customer conversations",
    img: "/json-media/img/SolutionPage/OD.svg",
    alt: "Ongoing Dialogue"
  },
  {
    title: "Unlimited Topics",
    description:
      "Discuss anything, not limited to the original scope of survey questions",
    img: "/json-media/img/SolutionPage/UT.svg",
    alt: "Unlimited Topics"
  },
  {
    title: "Segment Worldview",
    description:
      "Each avatar responds authentically from their segment’s perspective",
    img: "/json-media/img/SolutionPage/SW.svg",
    alt: "Segment Worldview"
  },
  {
    title: "Voice or Text",
    description: "Natural conversation through speaking or typing",
    img: "/json-media/img/SolutionPage/VOT.svg",
    alt: "Voice or Text"
  },
  {
    title: "Always Available",
    description:
      "24/7 access to customer insights and segment perspectives",
    img: "/json-media/img/SolutionPage/AA.svg",
    alt: "Always Available"
  },
  {
    title: "Dynamic Intelligence",
    description:
      "Test new marketing messages, product concepts, and service delivery strategies",
    img: "/json-media/img/SolutionPage/DI.svg",
    alt: "Dynamic Intelligence"
  }
];
export const IllustrativeResearchApplications = [
  {
    title: "Market Opportunity Assessment",
    description:
      "Identify, profile and dimensionalize the segments comprising a new market entry opportunity",
    img: "/json-media/img/SolutionPage/MOA.svg",
    alt: "Market Opportunity Assessment"
  },
  {
    title: "Consumer Sentiment Analysis",
    description:
      "Track consumer sentiment relative to your brand, your products and your overall customer experience",
    img: "/json-media/img/SolutionPage/CSA.svg",
    alt: "Consumer Sentiment Analysis"
  },
  {
    title: "Competitive Landscape Analysis",
    description:
      "Assess relative strengths and vulnerabilities of competitors within targeted segment populations",
    img: "/json-media/img/SolutionPage/CLA.svg",
    alt: "Competitive Landscape Analysis"
  },
  {
    title: "Living Customer Advisory",
    description:
      "Replace static panels with ongoing segment dialogue",
    img: "/json-media/img/SolutionPage/LCA.svg",
    alt: "Living Customer Advisory"
  },
  {
    title: "Message Development",
    description:
      "Refine difficult messages through real-time customer feedback",
    img: "/json-media/img/SolutionPage/MD.svg",
    alt: "Message Development"
  },
  {
    title: "Preliminary Research",
    description:
      "Conduct upfront research to help sharpen and focus the scope of subsequent traditional studies",
    img: "/json-media/img/SolutionPage/PR.svg",
    alt: "Preliminary Research"
  }
];
export const GenerativeInsightsMethod = [
  {
    title: "Urgent Need for Insight",
    description:
      "When the organization needs a robust, analytics-driven answer… but there’s no time for traditional research methods",
    img: "/json-media/img/SolutionPage/unfi.svg",
    alt: "Urgent Need for Insight"
  },
  {
    title: "Comprehensive Exploration",
    description:
      "When you need unlimited questioning without survey fatigue",
    img: "/json-media/img/SolutionPage/cd.svg",
    alt: "Comprehensive Exploration"
  },
  {
    title: "Ongoing Dialogue",
    description:
      "When you need continuous customer conversation beyond one-time studies",
    img: "/json-media/img/SolutionPage/DIALOGUE.svg",
    alt: "Ongoing Dialogue"
  },
  {
    title: "Hard-to-reach Segments",
    description:
      "When traditional recruitment is expensive or impossible",
    img: "/json-media/img/SolutionPage/hs.svg",
    alt: "Hard-to-reach Segments"
  }
];

export const TraditionalMethod = [
  {
    title: "Final\nValidation",
    description:
      "For launch-critical decisions requiring absolute precision",
    img: "/json-media/img/SolutionPage/fv.svg",
    alt: "Final Validation"
  },
  {
    title: "Emotional\nDepth",
    description:
      "When you need to understand deep emotional drivers through observation",
    img: "/json-media/img/SolutionPage/ed.svg",
    alt: "Emotional Depth"
  },
  {
    title: "Behavioral\nObservation",
    description:
      "For understanding actual, in-market behaviors",
    img: "/json-media/img/SolutionPage/bo.svg",
    alt: "Behavioral Observation"
  },
  {
    title: "Unspoken\nMotivations",
    description:
      "When the drivers of decisions remain unspoken… even online",
    img: "/json-media/img/SolutionPage/um.svg",
    alt: "Unspoken Motivations"
  }
];

